import React, { memo, useEffect, useState } from 'react'
import { Modal, Button } from '@ow/comps'
import StandardTree from './tree'

const footer = ({ close, submit, disabled }) => {
  return (
    <div className="flex justify-end gap-2">
      <Button stroke onClick={close}>
        取消
      </Button>
      <Button type="primary" onClick={submit} disabled={disabled}>
        确认
      </Button>
    </div>
  )
}

const StandardModal = ({
  trigger,
  open,
  onOpen,
  onClose,
  onConfirm,
  levelType,
  value = [],
}) => {
  const [selectedIds, setSelectedIds] = useState(value)

  const submit = () => {
    onConfirm(selectedIds)
  }

  useEffect(() => {
    setSelectedIds(value)
  }, [value])

  return (
    <Modal
      trigger={trigger}
      open={open}
      showCloseButton
      width="600px"
      title="选择绑定指标"
      closeOnDocumentClick={false}
      onOpen={onOpen}
      onClose={onClose}
      footer={({ close }) =>
        footer({
          disabled: !selectedIds.length,
          close,
          submit: () => {
            submit()
            close()
          },
        })
      }
    >
      <StandardTree
        value={selectedIds}
        setSelectedIds={setSelectedIds}
        levelType={levelType}
        checkable
      />
    </Modal>
  )
}

export default memo(StandardModal)
